export default __webpack_public_path__ + "static/media/market.4f9178e2.png";